import { AxiosService } from './axios.service'
import { SearchService } from './search.service'

export class UserEventsService extends SearchService {
	static save(params) {
		return AxiosService.post(`${'user-events'}`, params).then(
			({ data }) => data
		)
	}
}
